/**
 * Created by PanJiaChen on 16/11/18.
 */
 import { Message } from "element-ui";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
 export function parseTime(time, cFormat) {
  if (!time) {
    return ''
  }
  if (arguments.length === 0) {
  return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
  date = time
  } else {
  if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
  time = parseInt(time)
  }
  if ((typeof time === 'number') && (time.toString().length === 10)) {
  time = time * 1000
  }
  date = new Date(time)
  }
  const formatObj = {
  y: date.getFullYear(),
  m: date.getMonth() + 1,
  d: date.getDate(),
  h: date.getHours(),
  i: date.getMinutes(),
  s: date.getSeconds(),
  a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
  let value = formatObj[key]
  // Note: getDay() returns 0 on Sunday
  if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
  if (result.length > 0 && value < 10) {
  value = '0' + value
  }
  return value || 0
  })
  return time_str
  }
// 导出下载
export const exportBlob = (res, filename) => {
  const content = res.content
  const blob = new Blob([content])
  const fileName = filename || '下载文件.xlsx'
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
    Message({
      message: '操作成功，请前往浏览器“设置-下载”中查看',
      type: 'success'
    });
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}
/**
 *
 *
 * 时间组建快捷
 */
export const pickerOptions = {
  disabledDate(time) {
    return time.getTime() > new Date(parseTime(Date.now(), '{y}-{m}-{d} 23:59:59'));
  },
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}
// 点击复制
export const copy = (data) => {
  let url = data;
  let oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  document.execCommand("Copy"); // 执行浏览器复制命令
  Message({
    message: '复制成功',
    type: 'success'
  });
  oInput.remove()
}
/**
 * @param {string} url
 * @returns {string}
 */

 export function getUrlName (fileUrl) {
  if (!fileUrl) {
    return ''
  }else {
    let url = fileUrl.toString()
    return url.split("/").reverse()[0]
  }
 }

 /**
 * @param {number} authority_id
 * @returns {Boolean}
 */

  export function noAuthorityId (authority_id) {
    if (!authority_id) return true
    if (!this.authorityDetection(authority_id)) {
      this.$confirm("该账户暂无企业权限，请绑定企业", "提示", {
        confirmButtonText: "绑定企业",
        cancelButtonText: "取消",
        type: "",
      }).then(() => {
        this.$router.push({
          path: "/shezhi/company/info",
        });
      });
      return false
    } else {
      return true
    }
   }